module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharacter@2x.5647eb9.jpg";